<template>
  <div class="row">
    <div class="col-sm-5 col-xs-12">
      <div>
        <p class="h5 mb-0">Nombre de la Campaña</p>
        <p>{{ campaign.name }}</p>
      </div>
      <div>
        <p class="h5 mb-0">Cultivos</p>
        <ul class="text-left pl-3 pt-2">
          <li v-for="crop in campaign.crops" :key="crop.id">
            <i class="fas fa-seedling green mr-3"></i>{{ crop.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="col-sm-5 offset-sm-1 col-xs-12">
      <div>
        <p class="h5 mb-0">Fecha de inicio</p>
        <span>{{ campaign.from | date('DD/MM/YYYY') }}</span>
      </div>
      <div class="mt-4">
        <p class="h5 mb-0">Fecha de fin</p>
        <span>{{ campaign.to | date('DD/MM/YYYY') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
ul {
  list-style-type: none;
}
</style>
